import { render, staticRenderFns } from "./SuspendProgram.vue?vue&type=template&id=4923e07a"
import script from "./SuspendProgram.vue?vue&type=script&lang=ts"
export * from "./SuspendProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports